export default __webpack_public_path__ + "static/media/playstore.0ef6ec38.png";